/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { RowNode } from 'ag-grid-community';

import { toArray } from 'lodash';

/**
 * Runs animation on the grid row.
 * ag-grid has similar implementation found in cellComp.ts, but it does not allow to set another delay
 *
 * @param rootElement
 * @param row
 * @param baseClassName
 * @param delay
 */
export function animateGridRow(rootElement: HTMLElement, row: RowNode, baseClassName: string, delay: number): void {
  const cellElements: HTMLElement[] = toArray(rootElement.querySelectorAll(`[row-id="${row.id}"] .ag-cell`));

  const className = baseClassName;
  const animationClassName = `${baseClassName}-animation`;

  cellElements.forEach((cell) => {
    cell.classList.add(className);
  });

  setTimeout(
    () => {
      cellElements.forEach((cell) => {
        cell.classList.remove(className);
        cell.classList.add(animationClassName);
      });
      setTimeout(
        () => {
          cellElements.forEach((cell) => {
            cell.classList.add(animationClassName);
          });
        },
        delay);
    },
    500); // tslint:disable-line:no-magic-numbers
}
